import get from "lodash.get";
import Select from "react-select";
import styled from "styled-components";
import { sidebarWidth, sidebarWidthMobile } from "./navigator.constants";
import { useState } from "react";



export const HeaderStyled = styled.div`
  -webkit-box-shadow: 0px 3px 22px -3px ${({ theme }) => get(theme, "background.shadow")};
  -moz-box-shadow: 0px 3px 22px -3px ${({ theme }) => get(theme, "background.shadow")};
  box-shadow: 0px 3px 22px -3px ${({ theme }) => get(theme, "background.shadow")};
  padding-right: 6px;

  .header-left-side {
    display: flex;
    align-items: center;

    .global-search {
      position: relative;
      .search-input {
        > div {
          margin-bottom: 0 !important;
        }
        input {
          background: ${({ theme }) => get(theme, "background.main")};
          height: 36px;
          padding: 0 14px;
          border: 1px solid ${({ theme }) => get(theme, "border.main")} !important;
          font-size: 14px;
          width: 240px;
          &::placeholder {
            color: #888;
          }
        }
      }
      .list {
        position: absolute;
        margin-top: 10px;
        width: 130%;
        background: ${({ theme }) => get(theme, "background.main")};
        color: ${({ theme }) => get(theme, "text.main")} !important;
        border-radius: 12px;
        box-shadow: 0px 2px 12px -2px rgba(0, 0, 0, 0.3);
        overflow: auto;
        max-height: 80vh;
        z-index: 1000;
        .item-title {
          font-size: 16px;
          font-weight: bold;
          margin: 10px;
        }
        .item {
          padding: 10px 15px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          transition: 0.3s ease all;
          cursor: pointer;
          &:hover {
            background: ${({ theme }) => get(theme, "background.hoverPrimary")};
          }
          .name {
            display: block;
            font-size: 14px;
            line-height: 20px;
          }
          .phone {
            display: block;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
    h5 {
      margin-left: 2rem;
    }
    .logo-main {
      width: 172px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg path {
        fill: ${({ theme }) => get(theme, "primary.dark")};
      }
    }

    .react-select__control {
      padding: 0 8px !important;
    }
  }
  .header-right-side {
    &:hover {
      cursor: pointer;
    }
  }
`;

export const LanguageBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-right: 12px;

  button {
    font-size: 14px;
    font-weight: 600;
    border: none;
    outline: none;
    background-color: ${({ theme }) => theme.transparent};
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${({ theme }) => get(theme, "text.main")};

    &.active {
      color: ${({ theme }) => theme.primary.main};
    }
  }
`;

export const UserPopoverStyled = styled.div`
  width: 250px;
  color: ${({ theme }) => theme.text.main};
  .user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 0.7rem;
    width: 100%;
    cursor: pointer;
    border-radius: 10px;

    .image-div {
      img {
        width: 48px;
        height: 48px;
        object-fit: cover;
        object-position: center;
        border-radius: 50%;
      }
    }

    .name {
      margin-left: 0.5rem;
      font-weight: 700;
      font-size: 1rem;
      display: flex;
      flex-direction: column;

      .user_name {
        width: 180px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
      }
      .phone-number {
        font-size: 0.7rem;
        color: ${({ theme }) => get(theme, "secondary.main")};
      }
    }
    &:hover {
      background-color: ${({ theme }) => get(theme, "background.hoverPrimary")};
      transition: all 0.3s ease;
    }
  }
  .main_tab {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 100%;
    border-radius: 10px;
    &:hover {
      background-color: ${({ theme }) => get(theme, "background.hoverPrimary")};
      transition: all 0.3s ease;
    }
  }
`;

export const Loader = styled.div`
  transform: rotateZ(45deg);
  perspective: 1000px;
  border-radius: 50%;

  &:after,
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    animation: 1s spin linear infinite;
  }

  &:after {
    transform: rotateY(70deg);
    animation-delay: 0.4s;
  }

  &:before {
    transform: rotateX(70deg);
  }
`;

export const Container = styled.div<{ sidebar: boolean }>`
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
  padding-bottom: 50px;
  padding-left: ${(props) => (props.sidebar ? sidebarWidth : sidebarWidthMobile)};
  /* background: ${({ theme }) => get(theme, "background.main")}; */

`;
export const StyledBody = styled.div`
  padding: 20px;
  background: ${({ theme }) => get(theme, "background.primary")};
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;

interface CoverT {
  check: boolean;
}

export const Cover = styled.div`
  /* * {
    color: ${({ theme }) => get(theme, "secondary.main")};
  } */
  height: 100vh;
  width: 100vw;
  display: flex;
  overflow: hidden;
  .rightContent {
    width: 100%;

    transition: width, left, right, 0.3s;
  }
  .rightContentSmall {
    width: 100%;

    transition: width, left, right, 0.3s;
  }
`;

export const RoundedButton = styled.button`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 5px;
  transition: all 0.2s;
  box-shadow: none !important;
  svg {
    min-width: 24px !important;
  }
  &.active,
  &:hover {
    background-color: ${({ theme }) => get(theme, "background.hoverPrimary")};
  }
`;
export const UserStyled = styled.button`
  background: ${({ theme }) => get(theme, "form.light")};
  border-radius: 50%;
  padding: 0 3.5px;
  transition: all 0.2s;
  box-shadow: none !important;
  font-weight: 750;
  font-size: 25px;
  width: 36px;
  height: 36px;
  img {
    width: 36px;
    height: 36px;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
  }
  span {
    padding: 8.4px 5.5px;
    font-size: 20px;
    color: ${({ theme }) => theme.secondary.dark};
    transition: 0.2s ease all;
  }
  &:hover {
    span {
      color: ${({ theme }) => get(theme, "primary.main")};
    }
  }
`;

export const LinkStyled = styled.span`
  color: ${({ theme }) => get(theme, "info.dark")};
  transition: all 0.2s;
  font-size: 17px !important;
  &:hover {
    color: ${({ theme }) => get(theme, "primary.main")};
    cursor: pointer;
  }
`;

export const LanguageStyle = styled(Select)`
  .react-select__menu {
    z-index: 9999;
    background-color: ${({ theme }) => get(theme, "background.main")};

  }
  &:nth-child(3) {
    border-radius: 7px;
  }
  .react-select__control {
    cursor: pointer;
    border: none !important;
    color: ${({ theme }) => get(theme, "info.dark")};
    background-color: ${({ theme }) => get(theme, "background.main")};
    border-radius: 7px;
    .react-select__dropdown-indicator {
      padding-left: 0;
      .css-tj5bde-Svg {
        path {
          fill: ${({ theme }) => theme.secondary.main} !important;
        }
      }
    }
    &:hover {
      .react-select__single-value {
        transition: 0.2s ease;
        color: ${({ theme }) => get(theme, "primary.main")};
      }
      .react-select__indicator {
        svg {
          path {
            fill: ${({ theme }) => get(theme, "primary.main")} !important;
          }
        }
      }
    }
  }
  .react-select__value-container {
    .react-select__single-value {
      color: ${({ theme }) => theme.secondary.dark};
    }
    .react-select__multi-value {
      background-color: ${({ theme }) => get(theme, "white.light")};
      border-radius: 16px;
      display: flex;
      align-items: center;
      padding-right: 3px;

      .react-select__multi-value__label {
        color: ${({ theme }) => get(theme, "background.main")};
      }

      .react-select__multi-value__remove {
        color: ${({ theme }) => get(theme, "primary.dark")};
        background-color: ${({ theme }) => get(theme, "background.main")};
        padding: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
      }
    }
  }
  .react-select__menu {
    border-radius: 12px !important;
    margin: 16px 0 !important;

    border: none !important;
  }

  .react-select__indicator-separator {
    display: none;
  }

  & #react-select-3-listbox {
    background: ${({ theme }) => get(theme, "background.main")} !important;
    outline: none;
    box-shadow: none;

    div {
      div {
        background: ${({ theme }) => get(theme, "background.main")};
      }
    }
  }

  .react-select__placeholder {
    color: ${({ theme }) => get(theme, "info.dark")};
  }

  .react-select__indicator.react-select__dropdown-indicator,
  .react-select__indicator.react-select__clear-indicator {
    svg {
      transition: all, 0.2s !important;
      path {
        fill: ${({ theme }) => get(theme, "info.dark")} !important;
      }
    }
  }

  .react-select__menu {
    box-shadow: rgba(161, 161, 174, 0.91) 0 7px 29px 0 !important;
    margin: 3px 0;
    padding: 0;
    border-radius: 0;

    .react-select__menu-list {
      padding: 0;

      .react-select__option {
        color: ${({ theme }) => theme.secondary.dark} !important;
        transition: all 0.25s;

        &:first-child {
          border-top-right-radius: 12px !important;
          border-top-left-radius: 12px !important;
        }
        &:last-child {
          border-bottom-right-radius: 12px !important;
          border-bottom-left-radius: 12px !important;
        }
      }

      .react-select__option.react-select__option--is-focused {
        background: ${({ theme }) => get(theme, "white.light")} !important;

        &:hover {
          cursor: pointer;
        }
      }

      .react-select__option.react-select__option--is-selected {
        background: ${({ theme }) => get(theme, "primary.dark")} !important;
        color: ${({ theme }) => get(theme, "background.main")} !important;
      }
    }
  }

  & > div {
    border: 1px solid ${({ theme }) => get(theme, "white.light")} !important;
    box-shadow: none !important;
    border-radius: 12px;
    outline: none;
    color: ${({ theme }) => get(theme, "secondary.medium")};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: -0.02em;
    box-sizing: border-box;
    padding: 3px 3px;
    &:hover {
    }
  }
`;

export const NotificationIcon = styled("div")`
  position: relative;
  &::before {
  }
`;
